import React from 'react'
import getConfig from 'next/config'

import { style } from '../../../../components/Common/Index.style'
import Page from '../../../../components/Page/Page'
import PageHeader from '../../../../components/PageHeader/PageHeader'
import Content from '../../../../components/Content/Content'
import SectionTitle from '../../../../components/SectioinTitle'
import BackBtn from '../../../../components/Common/BackBtn'
import BreadCrumb from '../../../../components/Breadcrumbs/Breadcrumbs'

const { publicRuntimeConfig } = getConfig()
const basePath = publicRuntimeConfig.basePath

const pageTitle = '読者アンケート | 新潟県民だより'

const Home = () => {
  return (
    <Page title={pageTitle}>
      <PageHeader pageTitle="" />
      <SectionTitle sectionTitle="アンケートに答えてプレゼントが当たる！秋号読者アンケート" />
      <Content css={style.content}>
        <BreadCrumb
          lists={[
            {
              name: "HOME",
              path: "/"
            },
            {
              name: "2023秋号 No.164 目次",
              path: "/no164"
            },
            {
              name: "読者アンケート"
            }
          ]}
        />
        <p>県民だより秋号についてのご意見をお寄せください。抽選で下記の賞品をプレゼント！<br />
          次のように記入して、はがき等でご応募ください。</p>
        <p css={style.notetTxt}>※プレゼントは選べません。</p>
        
        <img
          src={`${basePath}/no164/img/4-6.png`}
          alt="ハガキの記入例"
          css={style.img(400)}
        />
        
        <p>メールアドレス：<a href="mailto:kenmindayori@pref.niigata.lg.jp">kenmindayori@pref.niigata.lg.jp</a></p>
        
        <p>〔締切〕<span css={style.emphasisWeight}>令和5年11月30日（木）</span>（当日消印有効）<br />〔発表〕当選者の発表は発送をもってかえさせていただきます。</p>
        
        <p>アンケートフォームは
          <a
            href="https://apply.e-tumo.jp/pref-niigata-u/offer/offerDetail_initDisplay?tempSeq=6380&accessFrom="
            target="_blank"
            rel="noreferrer"
          >
            <span>こちら</span>
          </a>
        </p>
        
        <hr />
        
        <h4 css={style.subTitle02}>新潟村上いわふね×山形おきたま&emsp;特産品セット【3名】</h4>
        <img
          src={`${basePath}/no164/img/4-7.png`}
          alt="新潟村上いわふね×山形おきたま　特産品セット"
          css={style.img(500, "15px 0 0 0")}
        />
        <p>胎内産コシヒカリ1kg（胎内）、七葉松味噌ドーナツ、ドリップパックコーヒー（加治川）、アップルパイ（米沢）</p>
        
        <hr />
        
        <h4 css={style.subTitle02}>こいぶみ（津南産コシヒカリ）精米2合【30名】</h4>
        <img
          src={`${basePath}/no164/img/4-8.png`}
          alt="こいぶみ（津南産コシヒカリ）精米2合"
          css={style.img(300, "15px 0 0 0")}
        />
        <p>津南町の豊かな自然力「ゆき みず だいち」で育まれたトップブランド「魚沼コシヒカリ」の新米をご賞味ください。</p>
        
        <hr />
        
        <h4 css={style.subTitle02}>佐渡島の金山オリジナルバッグ【10名】</h4>
        <img
          src={`${basePath}/no164/img/4-9.png`}
          alt="佐渡島の金山オリジナルバッグ"
          css={style.img(215, "15px 0 0 0")}
        />
        <p>「佐渡島の金山」のシンボルである道遊の割戸をデザインした非売品の不織布バッグです。</p>
        
        <hr />
        
        <p css={style.notetTxt}>【個人情報の取り扱いについて】ご記入いただいた個人情報は、プレゼントの抽選・発送および統計資料の作成に利用します。</p>
        
        <BackBtn href={"/no164"} />
      </Content>
    </Page>
  )
}
export default Home
